module.exports = __webpack_public_path__ + "static/media/dz.6bc7cc65.svg";